export default __webpack_public_path__ + "static/media/Image_OB_GuidelineUpdates@3x.9eaf5110.png";